import TitleCard from './TitleCard';

export * from './TitleCard';

export default TitleCard;
